module.exports = __webpack_public_path__ + "img/key.0f893798.svg";